import PropTypes from 'prop-types';
import styles from './styles';
import { withStyles } from 'tss-react/mui';
const DialogsManager = ({ dialogs, deleteItem, dialogByType = {} }) => dialogs.map(({ type, ...dialogProps }) => {
  const Dialog = dialogByType[type];

  return <Dialog onClose={deleteItem} key={type} {...dialogProps}/>;
});

DialogsManager.propTypes = {
  deleteItem: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  dialogByType: PropTypes.object,
};


export default withStyles(DialogsManager, styles);
